module.exports = __webpack_public_path__ + "static/CrimsonText-Regular-349919574aaabf85847318128b963b2c.woff2";